import React from 'react';

const FADVLogo = () => {
  return (
    <img
      alt="First Advantage"
      src="https://cdn.backgroundcheck.com/logos/FirstAdvantageLogo.svg"
      style={{ height: '100px', width: 'auto' }}
    />
  );
};

export default FADVLogo;
